export default "__VITE_ASSET__DeuyYYtw__"